<template>
  <FormComponent :app="app" :onSubmit="submit"></FormComponent>
</template>

<script>
import FormComponent from './form-component.vue';
import { AppModel } from '../../store/app-module';

export default {
  name: 'CreateApp',
  components: {
    FormComponent,
  },
  data: () => ({
    app: { ...AppModel },
  }),
  methods: {
    submit() {
      this.$store.dispatch('app/create', this.app)
        .then(() => {
          this.$router.push({ path: '/' });
        });
    },
  },
};
</script>
